import styled from 'styled-components';

const Wrapper = styled.div`
  margin: 21px 0px;
  display: flex;
  flex-flow: column;
  width: 100%;
  justify-content: center;
  align-items: center;
`;

const Text = styled.div`
  display: block;
  
  width: 100%;
  margin 15px 0px 0px;
  padding-bottom: 11px;
  
  border-bottom: 1px solid ${({ theme }) => theme.COLORS.LIGHT_SILVER};
  
  text-align: center;
  line-height: ${({ theme }) => theme.FONT_SIZES.LARGE};
  font-size: ${({ theme }) => theme.FONT_SIZES.LARGE};
  font-family: ${({ theme }) => theme.FONT.LIGHT};
`;

export default {
  Text,
  Wrapper
};
